export default function link({ variables }) {
    return {
        MuiLink: {
            defaultProps: {
                underline: "hover",
            },
            styleOverrides: {
                root: {
                    color: variables.text_link,
                    textDecorationColor: "currentColor",
                    "&:hover": {
                        color: variables.interactive_hover,
                    },
                },
            },
        },
    };
}
//# sourceMappingURL=link.js.map